module.exports = __webpack_public_path__ + "static/media/commnet-alt-slash.36c5ef46.svg";